import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectTrustField, {
  MxFormSelectTrustFieldProp
} from "@rf-l2/form/select/MxFormSelectTrustField";

interface MxFormL3SelectTrustFieldProps extends MxFormSelectTrustFieldProp {
  name: string;
  withreacthookform?: 1 | 0;
}
function MxFormL3SelectTrustField(props: MxFormL3SelectTrustFieldProps) {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormSelectTrustField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
}

export default MxFormL3SelectTrustField;
